import apiUrlProvider, { REQUEST_CHECK_QR, REQUEST_QR_PAYMENT } from 'constants/api-endpoints';
import { Observable } from 'rxjs';
import { DataRequestDTO, TokenResponseDTO } from './base/response-dao.base';
import { Rxios } from './base/Rxios';
import {
  PostQrPayment,
  RequestCheckQrCode,
} from './repository/PaymentServiceRepository/payment-service.type';

export interface PaymentServiceContractor {
  requestCheckQrCode: (qrid: string) => Observable<DataRequestDTO<RequestCheckQrCode>>;
  requestQrPayment: (qrid: string, payload: PostQrPayment) => Observable<TokenResponseDTO>;
}

export default class PaymentService extends Rxios implements PaymentServiceContractor {
  constructor() {
    const token = localStorage?.getItem('token');
    super({
      baseURL: process.env.NX_API_URL || '',
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  requestCheckQrCode = (qrid: string) => {
    const url = apiUrlProvider.get(REQUEST_CHECK_QR, { id: qrid });
    return this.get<DataRequestDTO<RequestCheckQrCode>>(url, {});
  };

  requestQrPayment = (qrid: string, payload: PostQrPayment) => {
    const url = apiUrlProvider.get(REQUEST_QR_PAYMENT, { id: qrid });
    return this.post<TokenResponseDTO>(url, payload);
  };
}
